import { render } from "./IconAlert.vue?vue&type=template&id=51b9cc26"
import script from "./IconAlert.vue?vue&type=script&lang=js"
export * from "./IconAlert.vue?vue&type=script&lang=js"

import exportComponent from "C:\\Users\\Tomi\\PhpstormProjects\\frontend-v2\\node_modules\\@vue\\cli-service\\node_modules\\vue-loader\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__